<template>
  <iBreadcrumb
    :style="{margin: '0 24px'}"
    class="header-breadcrumb">
    <iBreadcrumbItem
      v-for="(breadcrumb, index) in breadcrumbs"
      :key="index"
      :to="breadcrumb.path"
    >
      <span
        v-if="breadcrumb.loading"
        key="breadcrumb-text"
        class="loading"/>
      <span
        v-else-if="breadcrumb.label"
        key="breadcrumb-text"
        v-text="breadcrumb.label"/>
      <span
        v-else-if="breadcrumb.i18n"
        key="breadcrumb-text"
      >{{ $t(breadcrumb.i18n) }}</span>
    </iBreadcrumbItem>
  </iBreadcrumb>
</template>

<script>
export default {
  name: 'HeaderBreadcrumb',
  data() {
    return {
      componentBreadcrumbs: {},
    };
  },
  computed: {
    breadcrumbs() {
      return this.getBreadcrumbs(this.$route).reverse();
    },
  },
  created() {
    this.$breadcrumbEventBUS.$on('$breadcrumbChanged', ({ breadcrumb, route }) => {
      this.$set(this.componentBreadcrumbs, route.path, breadcrumb);
    });
    this.$breadcrumbEventBUS.$on('$breadcrumbDelete', ({ route }) => {
      this.$delete(this.componentBreadcrumbs, route.path);
    });
  },
  methods: {
    resolveRoute(routeMatch) {
      const { name } = routeMatch;
      if (!name) return undefined;
      const { params } = this.$route;
      const { route } = this.$router.resolve({ name, params });
      return route;
    },
    getBreadcrumbs(route) {
      let parts = [];
      route.matched.slice().reverse().some((routeMatch) => {
        const breadcrumb = this.getRouteBreadcrumb(routeMatch);
        if (!breadcrumb) return false;

        parts.push(breadcrumb);

        if (breadcrumb.parent) {
          const { route: parentRoute } = this.$router.resolve({
            ...route,
            name: breadcrumb.parent,
          });
          parts = parts.concat(this.getBreadcrumbs(parentRoute));
          return true;
        }
        return false;
      });
      return parts;
    },
    getRouteBreadcrumb(routeMatch) {
      let { breadcrumb } = routeMatch.meta;
      let { breadcrumb: compBreadcrumb } = routeMatch.components.default;
      if (!(breadcrumb || compBreadcrumb)) return false;

      const defaultBreadcrumb = this.defaultBreadcrumb(routeMatch);
      breadcrumb = this.getBreadcrumb(breadcrumb);
      compBreadcrumb = this.getCompBreadcrumb(compBreadcrumb, routeMatch);

      return { ...defaultBreadcrumb, ...breadcrumb, ...compBreadcrumb };
    },
    getCompBreadcrumb(breadcrumb, routeMatch) {
      switch (typeof breadcrumb) {
        case 'function': {
          const { path } = this.resolveRoute(routeMatch);
          return this.componentBreadcrumbs[path] || {};
        }
        default:
          return this.getBreadcrumb(breadcrumb);
      }
    },
    getBreadcrumb(breadcrumb) {
      switch (typeof breadcrumb) {
        case 'undefined':
          return {};
        case 'boolean':
          return {};
        case 'string':
          return { i18n: breadcrumb };
        case 'function':
          return breadcrumb();
        case 'object':
          return breadcrumb;
        default:
          throw new Error('unsupported breadcrumb type');
      }
    },
    defaultBreadcrumb(routeMatch) {
      const route = this.resolveRoute(routeMatch);
      return {
        i18n: this.$t(routeMatch.meta.title),
        path: route ? route.path : '',
      };
    },
  },
};
</script>

<style>
.header-breadcrumb {
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header-breadcrumb a {
  color: #fff;
}

.loading:after {
  content: ' .';
  animation: dots 1s steps(5, end) infinite;
}

@keyframes dots {
  0%, 20% {
    color: rgba(0,0,0,0);
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);
  }
  40% {
    color: white;
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);
  }
  60% {
    text-shadow:
      .25em 0 0 white,
      .5em 0 0 rgba(0,0,0,0);
  }
  80%, 100% {
    text-shadow:
      .25em 0 0 white,
      .5em 0 0 white;
  }
}
</style>
